import _ from 'lodash'
import {
	shortenedAndUnshortened
} from 'scoreboard/components/format-value'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, PERCENT } = DataType

function datasetFormatter (field, aggregationType, opt = {}) {
	if (field) {
		field = field.attributes || field

		// #18514 if the field's data type is numeric, use the specified data type.
		// For non-numeric data fields, we're aggregating by "unique value", which
		// would just be a number
		let dataType = isNumericDataType(field.dataType) ? field.dataType : NUMBER

		_.defaults(opt, {
			dataType: dataType,
			precision: field.precision,
			currencyCode: field.currencyCode
		})
	} else {
		_.extend({ opt, dataType: NUMBER })
	}

	// #16995 if using percentage aggregation, override whatever the field's data type was
	if (aggregationType === 'percentage') {
		opt.dataType = PERCENT
	}

	if (aggregationType === 'unique') {
		// #43330 When using 'Number of Unique', we are returning a tally, so it
		// should be formatted as a number, regardless of the actual data type
		opt.dataType = NUMBER
	}

	return function (value) {
		return shortenedAndUnshortened(_.extend({ value }, opt))
	}
}

// TODO once we get rid of the old chart code, this should really be the main
// function for this module
function datasetAggregationFormatter ({ aggregation, chartData } , options = {}) {
	let dataset = chartData.datasetModel(aggregation.startingDatasetId)

	if (aggregation.dataSourceType === 'basic') {
		let datasetField = dataset.combinedFieldsById[aggregation.fieldId]
		return datasetFormatter(datasetField, aggregation.aggregationType, options)
	} else {
		return function (value) {
			let opt = {
				dataType: aggregation.dataType
			}

			return shortenedAndUnshortened(_.extend({ value }, opt, options))
		}
	}
}

export default datasetFormatter
export { datasetAggregationFormatter }

datasetFormatter.__filename__ = 'charts/chart-data/dataset-formatter.js'
